import * as z from 'zod'
import { PostApiContract } from './ApiContract.js'

export const postDocPresignedSchema = z.object({
    filename: z.string(),
})

export interface PostDocPresignedRequest extends PostApiContract {
    Body: z.infer<typeof postDocPresignedSchema>
    Response: {
        filename: string
        uploadUrl: string
    }
    ResponseJson: {
        filename: string
        uploadUrl: string
    }
}
